import React from 'react';
import PropTypes from 'prop-types';
import Styles from './RadioButton.module.scss';

const RadioButton = ({
  name,
  value,
  checked,
  disabled,
  setFieldValue = () => {},
  onChange = () => {}
}) => {
  const handleChange = value => {
    setFieldValue(name, value);
  };

  return (
    <input
      type="radio"
      name={name}
      value={value}
      disabled={disabled}
      className={Styles['radio-button']}
      checked={checked}
      onChange={event => {
        handleChange(event.target.value);
        onChange(event);
      }}
    />
  );
};

RadioButton.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  setFieldValue: PropTypes.func,
  onChange: PropTypes.func
};

export default RadioButton;
